<template>
  <div class="seomain">
    <st-header
      title="订单详情"
      :back-able="true"
      :close-able="true"
    >
      <template slot="header-right">
        <span>
          更多
        </span>
      </template>
    </st-header>
    <div class="tab-content " v-loading="loading">
      <div class="st-list-box pan-1">
        <div class="st-list" v-for="(item, i) in details">
          <div class="st-list-top">
            <div class="t-tit">{{ item.code }}</div>
            <div class="t-status">{{ item.qualityname }}</div>
          </div>
          <div class="st-list-main">
            <p>SKU： {{ item.sku }}</p>
            <p>品&emsp;&emsp;类：{{ item.cname }}</p>
            <p>品&emsp;&emsp;牌：{{ item.brand }}</p>
            <p>供&nbsp;&nbsp;应 商：{{ item.supplier_name }}</p>
            <p>联&nbsp;&nbsp;系 人：{{ item.supplier_contactone }}</p>
            <p>联系电话：{{ item.supplier_contactonenumber }}</p>
            <p>联系地址：{{ item.supplier_adderss }}</p>
            <p>采&nbsp;&nbsp;购 价：{{ item.purchase_money }}</p>
            <p>上次采购价：{{ item.last_purchase_money }}</p>
            <p>预计交期：{{ item.deliverytime }}</p>
            <p>采购数量：{{ item.purchase_num }}</p>
            <p>已&nbsp;&nbsp;入 库：{{ item.storageed }}</p>
            <p style="color: red;">待&nbsp;&nbsp;入 库：{{ item.storageing }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
export default {
  components: {
    "st-header": StHeader,
  },
  props: {},
  data() {
    return {
      details: [],
      code: this.$route.query.code,
      loading: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    getDetails() {
      this.loading = true;
      this.$post(this.$api.stPurchaseInfo, { id: this.$route.params.id }).then((res) => {
        if (res.code !== 1) {
          this.$toast.fail(res.msg ? res.msg : '网络请求异常，请稍后重试');
        }
        this.details = res['data']['items'];
        this.loading = false;
      });
    },
  },
  created() {
    this.getDetails();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "采购入库" });
    });
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
  .tab-content {
    .pan-1 { 
      .t-tit {
        padding-left: 2px;
        font-size: 16px;
        border-left-color: #3eb399;
      }
      .t-status {
        font-size: 16px;
        line-height: 21px;
        color: #3eb399;
      }
      .st-list-bottom-2 {
        background-color: white;
        display: flex;
        justify-content: space-between;
        width: 100%;
        .van-button {
          width: 40%;
          border-radius: 8px;
        }
      }
    }
  }
</style>
